<template>
  <div class="content">
    <el-image class="logo" :src="src" fit="cover"></el-image>
    <div class="infos">
      <div class="info" v-for="(item,i) in list" :key="i" @click="detail(item)">
        <el-image class="img" :src="item.picture_link_list[0]" fit="cover"></el-image>
        <p>{{item.product_name}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { adminProductInfo,adminConfigInfo } from "@/request/api";
export default {
  name: "HomeView",
  data() {
    return {
      page: 1,
      size: 8,
      list: [],
      src:''
    };
  },
  created() {
    this.getInfo()
    this.getList();
  },
  methods: {
    getInfo() {
      adminConfigInfo().then(res => {
        console.log(res);
        // this.contact_title = res.results[0].contact_title;
        // this.about_body = res.results[0].about_body;
        // this.logo_image = res.results[0].logo;
        this.src = res.results[0].home_page;
        // this.about_image = res.results[0].about_page;
      });
    },
    detail(e){
      this.$router.push({ path: '/details', query: { info: e } })
    },
    getList() {
      adminProductInfo({
        page: this.page,
        page_size: this.size
      }).then(res => {
        console.log(res);
        this.list = res.results[0].results;
      });
    }
  }
};
</script>

<style scoped>
.logo {
  width: 100%;
  height: 500px;
}
.infos {
  display: flex;
  justify-content: center;
  flex-wrap: wrap; /* 使得内容自动换行 */
  gap: 16px; /* 元素之间的间距 */
  margin-top: 40px;
}

.info {
  width: 23%; /* 每个 .info 元素占 23% 的宽度，四个元素可以放在一行 */
  box-sizing: border-box;
  text-align: center;
  margin-bottom: 70px;
}

.img {
  width: 400px;
  height: 400px;
}

p {
  font-size: 20px;
  margin-top: 8px;
}
</style>


// WEBPACK FOOTER //
// src/components/Order.vue